// todo social auth
// todo remember me checkbox
// todo forgot you password link

import type { FC } from 'react'
import React, { useState } from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { FormikProps } from 'formik'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { Typography, Button, TextField, Snackbar } from '@homeviews/shared-ui'
import {
  toggleUpgradeForm,
  getUser,
  useUpgradeCompanyMutation,
} from '@homeviews/store'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    separator: {},
    formFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      marginBottom: theme.spacing(2.5),
    },
    radios: {},
    cancelButton: {
      marginRight: 6,
    },
    alertText: {
      display: 'flex',
      alignItems: 'flex-start',
      margin: '20px 0',
      '& img': {
        marginRight: 10,
        flexShrink: 0,
        width: 15,
        marginTop: 2,
      },
    },
    title: {
      marginBottom: 15,
      marginTop: -20,
    },
    subtitle: {
      marginBottom: 20,
    },
  }),
)

interface IUpgradeForm {
  email: string
  // phone_number: string
  // contact_method: string
}

const UpgradeForm: FC = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const user = useSelector(getUser)

  const [loading, setLoading] = useState<boolean>(false)
  const [formError, setFormError] = useState<string>('')

  const [snackbarVisible, setSnackbarVisible] = useState<{
    open: boolean
    message: string
    status?: 'success' | 'error'
  }>({
    open: false,
    message: '',
    status: undefined,
  })

  const [upgradeCompany] = useUpgradeCompanyMutation()

  const onSubmit = async (values: IUpgradeForm) => {
    setLoading(true)

    const payload = {
      contact_email: values.email,
    }

    try {
      const response = (await upgradeCompany({
        developerId: user?.developer_id,
        data: payload,
      })) as any

      if (!response?.data?.message_sent) {
        handleResponseError()
      } else {
        setSnackbarVisible({
          open: true,
          message: 'Request has been sent',
        })

        setTimeout(() => {
          dispatch(toggleUpgradeForm({ open: false }))
        }, 3000)
      }
    } catch (err) {
      console.log(err)
      handleResponseError()
    } finally {
      setLoading(false)
    }
  }

  function handleResponseError() {
    setSnackbarVisible({
      open: true,
      message: 'Oops, something went wrong',
      status: 'error',
    })
  }

  const handleSnackbarClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return
    }

    setSnackbarVisible({
      open: false,
      message: snackbarVisible?.message,
      status: snackbarVisible?.status,
    })
  }

  return (
    <>
      <div className={classes.root}>
        <Typography variant="h1" className={classes.title}>
          Upgrade my account
        </Typography>
        <Typography className={classes.subtitle}>
          To access this page you may need to upgrade your account. Add your
          email below and someone from the accounts team will get in touch to
          discuss the options available to you.
        </Typography>
        <Formik
          initialValues={{
            email: user?.email || '',
            // phone_number: '',
            // contact_method: 'email'
          }}
          onSubmit={onSubmit}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email('Enter valid email')
              .required('Email field is required'),
            // phone_number: Yup.string(),
            // contact_method: Yup.string()
          })}
        >
          {(props: FormikProps<IUpgradeForm>) => {
            const { values, touched, errors, handleBlur, handleChange } = props

            return (
              <Form>
                <TextField
                  label="Email address"
                  value={values.email}
                  data-id="t-email"
                  id="email"
                  error={errors.email && touched.email ? true : false}
                  helperText={errors.email}
                  onChange={(e) => {
                    handleChange(e)
                    setFormError('')
                  }}
                  onBlur={handleBlur}
                  fullWidth
                />
                {/* <TextField
                  label="Phone number"
                  value={values.phone_number}
                  data-id="t-phone_number"
                  id="phone_number"
                  type="phone_number"
                  autoComplete="current-phone_number"
                  error={
                    errors.phone_number && touched.phone_number ? true : false
                  }
                  helperText={errors.phone_number}
                  onChange={(e) => {
                    handleChange(e)
                    setFormError('')
                  }}
                  onBlur={handleBlur}
                  fullWidth
                />
                <div className="l-fieldWrapper">
                  <div className="l-labelFieldWrapper">
                    <label>Prefered contact method</label>
                  </div>
                  <RadioGroup
                    aria-label="contact_method"
                    name="contact_method"
                    value={values?.contact_method}
                    onChange={handleChange}
                    className={classes.radios}
                    row
                  >
                    <FormControlLabel
                      value="email"
                      control={<Radio color="primary" />}
                      label="Email"
                    />
                    <FormControlLabel
                      value="phone_number"
                      control={<Radio color="primary" />}
                      label="Phone"
                    />
                  </RadioGroup>
                </div> */}
                <Typography className={classes.alertText}>
                  <img
                    src="assets/icons/medium/alert-primary_v2.svg"
                    alt="Info icon"
                  />
                  Once submitted one of the team will be in touch via phone or
                  email to discuss your request within 1 working day.
                </Typography>
                <div className={classes.formFooter}>
                  <Button
                    variant="outlined"
                    customColor="dark"
                    onClick={() => dispatch(toggleUpgradeForm({ open: false }))}
                    className={classes.cancelButton}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    customColor="primary"
                    isLoading={loading}
                  >
                    Send request
                  </Button>
                </div>

                {formError && (
                  <Typography className="l-errorMessage">
                    {formError}
                  </Typography>
                )}
              </Form>
            )
          }}
        </Formik>
      </div>
      <Snackbar
        open={snackbarVisible?.open}
        onClose={handleSnackbarClose}
        alertMessage={snackbarVisible?.message}
        status={snackbarVisible?.status}
      />
    </>
  )
}

export default UpgradeForm
